<template>
  <div>
    <div class="card card-custom card-sticky" v-if="!mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer">
            <span class="label label-xl label-dot label-primary mr-2"></span> Turno 1 <!--- Local (06:00 - 13:00)-->
            <small v-if="ui.estaCargandoDatos" class="">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{ auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="doCargarFicha()"><i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin ' : '']"></i></a>
        </div>
      </div>
    </div>
    <div class="card card-custom card-sticky" v-if="mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
            <span class="label label-xl label-dot label-primary mr-2"></span> Turno 1 <!---Local (06:00 - 13:00)-->
            <small class="">{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" @click.prevent="doGuardado()"><i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i> Guardar cambios</a>
          <a href="#" class="btn btn-sm btn-light-warning font-weight-bold" @click.prevent="$emit('update:expandirContenido', !expandirContenido)"><i class="fa p-0" :class="[expandirContenido ? 'fa-chevron-up' : 'fa-chevron-down']"></i></a>
        </div>
      </div>
      <div class="card-body px-3 px-md-9 py-4 py-md-8" v-show="expandirContenido">
        <div class="alert alert-light p-6">
          <h4 class="mb-3 font-weight-bold">Registro de Asistencia</h4>
          <form class="form" id="frm-local-ficha-asistencia" @submit.prevent>
          <div class="row">
            <div class="form-group col-12 col-md-4">
              <label class="mb-1">Nombre del Observador</label>
              <input type="text" class="form-control" v-model="actual.observadorNombre" placeholder="Nombres y apellidos" autocomplete="off" required />
            </div>
            <div class="form-group col-12 col-md-4">
              <label class="mb-1">DNI</label>
              <input type="text" class="form-control" v-model="actual.observadorDni" placeholder="Número de documento de identidad" autocomplete="off" required />
            </div>
            <div class="form-group col-12 col-md-4">
              <label class="mb-1">Local de Votación</label>
              <input type="text" class="form-control" :value="localNombre" disabled />
            </div>
            <div class="form-group col-12">
              <label class="mb-1 font-weight-bold">Registro de asistencia</label>
              <div class="btn-group d-flex flex-wrap" role="group">
                <button type="button" @click.prevent="seleccionarPermitioIngreso(true)" class="btn flex-fill" :class="[actual.b1PermitioIngresoLocalVotacion === true ? 'btn-success' : 'btn-outline-secondary']"><i class="fa fa-door-open mr-2"></i>Ingresé al local de votación</button>
                <button type="button" @click.prevent="seleccionarPermitioIngreso(false)" class="btn flex-fill" :class="[actual.b1PermitioIngresoLocalVotacion === false ? 'btn-danger' : 'btn-outline-secondary']"><i class="fa fa-ban mr-2"></i>No se permitió el ingreso para la observación electoral</button>
              </div>
              <div v-if="actual.b1PermitioIngresoLocalVotacion === false" class="alert alert-custom alert-light-warning mt-3 mb-0 py-2">
                <i class="fa fa-info-circle mr-1"></i> Has registrado que no se permitió el ingreso. No es necesario completar el cuestionario.
              </div>
            </div>
          </div>
          </form>
        </div>
        <form v-show="registroAsistenciaCompleto" class="form" id="frm-local-ficha">
          <div class="row">
            <div class="col-xl-2 d-none d-xl-block"></div>
            <div class="col-12 col-xl-8">

              <!-- BLOQUE 2: Infraestructura -->
              <div class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">
                  <i class="fa fa-building text-primary mr-2"></i> II. Infraestructura
                </h3> -->

                <div :class="sheetRowQClass(true, sheetB21Completa)">
                  <label :class="ui.colLeftClass">
                    1. ¿El local de votación cuenta con electricidad?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.b2LocalConElectricidad = true" class="btn" :class="[actual.b2LocalConElectricidad === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.b2LocalConElectricidad = false" class="btn" :class="[actual.b2LocalConElectricidad === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                  </div>
                </div>
                <div :class="sheetRowQClass(true, sheetB31Completa)">
                  <label :class="ui.colLeftClass">
                    2. Hay presencia de:
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group flex-wrap mb-2" role="group">
                      <button type="button" @click.prevent="actual.b3PresenciaOnpe = !actual.b3PresenciaOnpe" class="btn" :class="[actual.b3PresenciaOnpe ? 'btn-primary' : 'btn-outline-secondary']">ONPE</button>
                      <button type="button" @click.prevent="actual.b3PresenciaJne = !actual.b3PresenciaJne" class="btn" :class="[actual.b3PresenciaJne ? 'btn-primary' : 'btn-outline-secondary']">JNE</button>
                      <button type="button" @click.prevent="actual.b3PresenciaFfaaPnp = !actual.b3PresenciaFfaaPnp" class="btn" :class="[actual.b3PresenciaFfaaPnp ? 'btn-primary' : 'btn-outline-secondary']">FFAA / PNP</button>
                      <button type="button" @click.prevent="actual.b3PresenciaMinisterioPublico = !actual.b3PresenciaMinisterioPublico" class="btn" :class="[actual.b3PresenciaMinisterioPublico ? 'btn-primary' : 'btn-outline-secondary']">Ministerio Público</button>
                      <button type="button" @click.prevent="actual.b3PresenciaDefensoriaDelPueblo = !actual.b3PresenciaDefensoriaDelPueblo" class="btn" :class="[actual.b3PresenciaDefensoriaDelPueblo ? 'btn-primary' : 'btn-outline-secondary']">Defensoría del Pueblo</button>
                    </div>
                    <div class="form-check mt-2">
                      <input class="form-check-input" type="checkbox" v-model="actual.b3PresenciaOtros" id="chkPresenciaOtros">
                      <label class="form-check-label" for="chkPresenciaOtros">Otros</label>
                    </div>
                    <div v-if="actual.b3PresenciaOtros">
                      <textarea v-model="actual.b3PresenciaOtrosDetalle" class="form-control mt-2" placeholder="Indicar el nombre de la entidad..." required></textarea>
                    </div>
                  </div>
                </div>
                <div :class="sheetRowQClass(true, sheetB23Completa)">
                  <label :class="ui.colLeftClass">
                    3. ¿El local de votación esta debidamente señalizado, y cuenta con mecanismos que permitan la identificación y ubicación de la mesa de votación, accesos y salidas?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.b2LocalSenializado = true" class="btn" :class="[actual.b2LocalSenializado === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.b2LocalSenializado = false" class="btn" :class="[actual.b2LocalSenializado === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.b2LocalSenializado === false">
                      <textarea v-model="actual.b2LocalSenializadoDetalle" class="form-control mt-2" placeholder="Señale brevemente por qué..." required></textarea>
                    </div>
                  </div>
                </div>
                <div :class="sheetRowQClass(true, sheetB22Completa)">
                  <label :class="ui.colLeftClass">
                    4. ¿Existen mecanismos de acceso para personas con discapacidad, embarazadas y/o adultos mayores al local de votación?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.b2AccesoPersonasVulnerables = true" class="btn" :class="[actual.b2AccesoPersonasVulnerables === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.b2AccesoPersonasVulnerables = false" class="btn" :class="[actual.b2AccesoPersonasVulnerables === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                  </div>
                </div>


              </div>

              <!-- BLOQUE 3: Entorno Electoral -->
              <div class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">
                  <i class="fa fa-vote-yea text-primary mr-2"></i> III. Entorno Electoral
                </h3> -->


                <div :class="sheetRowQClass(true, sheetB33Completa)">
                  <label :class="ui.colLeftClass">
                    5. ¿Observas algún tipo de propaganda electoral en el local de votación?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.b3PropagandaEnLocal = true" class="btn" :class="[actual.b3PropagandaEnLocal === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="limpiarPropagandaLocal()" class="btn" :class="[actual.b3PropagandaEnLocal === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.b3PropagandaEnLocal === true" class="mt-2">
                      <label class="mb-1">Organización política:</label>
                      <div class="btn-group d-flex flex-wrap" role="group">
                        <button v-for="partido in partidosNacionales" :key="partido.parametroId" type="button" @click.prevent="togglePartidoCsv('b3PropagandaEnLocalOrganizacionParamIds', partido.parametroId)" class="btn btn-sm" :class="[isPartidoSelected('b3PropagandaEnLocalOrganizacionParamIds', partido.parametroId) ? 'btn-primary' : 'btn-outline-secondary']">
                          <img :src="getImagenPartidoPolitico(partido.parametroId)" style="height:20px;width:auto;vertical-align:middle;" class="mr-1" />
                          {{ partido.descripcion }}
                        </button>
                      </div>
                      <small v-if="parsePartidoIds(actual.b3PropagandaEnLocalOrganizacionParamIds).length === 0" class="text-danger d-block mt-1">Selecciona al menos una organización política.</small>
                      <textarea required v-model="actual.b3PropagandaEnLocalDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..."></textarea>
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetB32Completa)">
                  <label :class="ui.colLeftClass">
                    6. En el local de votación, ¿se ha habilitado un área para el SUFRAGIO en el primer piso para personas con discapacidad o adultos mayores?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.b3AreaSufragioPrimerPiso = true" class="btn" :class="[actual.b3AreaSufragioPrimerPiso === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.b3AreaSufragioPrimerPiso = false" class="btn" :class="[actual.b3AreaSufragioPrimerPiso === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.b3AreaSufragioPrimerPiso === false">
                      <textarea v-model="actual.b3AreaSufragioPrimerPisoDetalle" class="form-control mt-2" placeholder="Señale en qué piso se ubica..." required></textarea>
                    </div>
                  </div>
                </div>


              </div>

              <!-- BLOQUE 4: Incidencias -->
              <div class="mt-4 mt-md-5">
                <!-- <h3 class="text-dark font-weight-bold mb-4 mb-md-10">
                  <i class="fa fa-exclamation-triangle text-primary mr-2"></i> IV. Incidencias
                </h3> -->

                <div :class="sheetRowQClass(true, sheetB41Completa)">
                  <label :class="ui.colLeftClass">
                    7. ¿Se presentó/produjo algún incidente que limita o impida el ejercicio de tus funciones como observador/a electoral?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.b4IncidenteLimitaLaborObservador = true" class="btn" :class="[actual.b4IncidenteLimitaLaborObservador === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.b4IncidenteLimitaLaborObservador = false" class="btn" :class="[actual.b4IncidenteLimitaLaborObservador === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.b4IncidenteLimitaLaborObservador === true">
                      <textarea v-model="actual.b4IncidenteLimitaLaborObservadorDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                    </div>
                    <div v-if="actual.b4IncidenteLimitaLaborObservador === true" class="alert alert-custom alert-light-warning mt-2 mb-0 py-2">
                      <i class="fa fa-bell mr-1"></i> Recuerda que también debes registrar la información en el botón de alerta.
                    </div>
                  </div>
                </div>

                <div :class="sheetRowQClass(true, sheetB42Completa)">
                  <label :class="ui.colLeftClass">
                    8. ¿Se ha detectado algún acto de intimidación, coacción, agresión o violencia que impida el ejercicio del voto ciudadano en tu local de votación?
                  </label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group" role="group">
                      <button type="button" @click.prevent="actual.b4ActoIntimidacionOViolencia = true" class="btn" :class="[actual.b4ActoIntimidacionOViolencia === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.b4ActoIntimidacionOViolencia = false" class="btn" :class="[actual.b4ActoIntimidacionOViolencia === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.b4ActoIntimidacionOViolencia === true">
                      <textarea v-model="actual.b4ActoIntimidacionOViolenciaDetalle" class="form-control mt-2" placeholder="Señale brevemente el detalle..." required></textarea>
                    </div>
                    <div v-if="actual.b4ActoIntimidacionOViolencia === true" class="alert alert-custom alert-light-warning mt-2 mb-0 py-2">
                      <i class="fa fa-bell mr-1"></i> Recuerda que también debes registrar la información en el botón de alerta.
                    </div>
                  </div>
                </div>
              </div>

              <!-- CIERRE: preguntas 9, 10 y 11 retiradas del cuestionario; los campos se envían vacíos al API. -->
            </div>
            <div class="col-xl-2 d-none d-xl-block"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { sheetBoolAnswered, sheetNonEmpty } from "@/helpers/sheetQuestion.js";

export default {
  name: "ficha-turno-1-local-2026",
  props: {
    localVotacionId: { type: Number },
    procesoElectoralId: { type: Number },
    expandirContenido: { type: Boolean },
    intervaloAutoGuardado: { type: Number },
  },
  data: () => ({
    auth: {
      autorizadoEdicionTurno: null,
      mensajeNoAutorizadoEdicionTurno: null,
      fechaInicioTurno: null,
      fechaFinTurno: null,
    },
    ui: {
      colLeftClass: "col-12 col-md-5 col-form-label",
      colRightClass: "col-12 col-md-7",
      estaGuardando: false,
      estaCargandoDatos: false,
      tieneCargaInicial: false,
    },
    temporizadorGuardado: null,
    localNombre: null,
    actual: {
      observadorNombre: null,
      observadorDni: null,
      b1PermitioIngresoLocalVotacion: null,
      b2LocalConElectricidad: null,
      b2AccesoPersonasVulnerables: null,
      b2LocalSenializado: null,
      b2LocalSenializadoDetalle: null,
      b3PresenciaOnpe: null,
      b3PresenciaJne: null,
      b3PresenciaFfaaPnp: null,
      b3PresenciaMinisterioPublico: null,
      b3PresenciaDefensoriaDelPueblo: null,
      b3PresenciaOtros: null,
      b3PresenciaOtrosDetalle: null,
      b3AreaSufragioPrimerPiso: null,
      b3AreaSufragioPrimerPisoDetalle: null,
      b3PropagandaEnLocal: null,
      b3PropagandaEnLocalOrganizacionParamId: null,
      b3PropagandaEnLocalOrganizacionParamIds: null,
      b3PropagandaEnLocalDetalle: null,
      b4IncidenteLimitaLaborObservador: null,
      b4IncidenteLimitaLaborObservadorDetalle: null,
      b4ActoIntimidacionOViolencia: null,
      b4ActoIntimidacionOViolenciaDetalle: null,
      cHoraCierreLocal: null,
      cQuedaronPersonasEsperandoVotar: null,
      cSePermitioVotarTrasCierre: null,
    },
    guardado: {
      observadorNombre: null,
      observadorDni: null,
      b1PermitioIngresoLocalVotacion: null,
      b2LocalConElectricidad: null,
      b2AccesoPersonasVulnerables: null,
      b2LocalSenializado: null,
      b2LocalSenializadoDetalle: null,
      b3PresenciaOnpe: null,
      b3PresenciaJne: null,
      b3PresenciaFfaaPnp: null,
      b3PresenciaMinisterioPublico: null,
      b3PresenciaDefensoriaDelPueblo: null,
      b3PresenciaOtros: null,
      b3PresenciaOtrosDetalle: null,
      b3AreaSufragioPrimerPiso: null,
      b3AreaSufragioPrimerPisoDetalle: null,
      b3PropagandaEnLocal: null,
      b3PropagandaEnLocalOrganizacionParamId: null,
      b3PropagandaEnLocalOrganizacionParamIds: null,
      b3PropagandaEnLocalDetalle: null,
      b4IncidenteLimitaLaborObservador: null,
      b4IncidenteLimitaLaborObservadorDetalle: null,
      b4ActoIntimidacionOViolencia: null,
      b4ActoIntimidacionOViolenciaDetalle: null,
      cHoraCierreLocal: null,
      cQuedaronPersonasEsperandoVotar: null,
      cSePermitioVotarTrasCierre: null,
    },
    partidos: [],
  }),
  computed: {
    partidosNacionales() {
      return (this.partidos || []).filter(p => p.regionId == 0);
    },
    isDirty() {
      return JSON.stringify(this.actual) != JSON.stringify(this.guardado);
    },
    mostrarDetalleFicha() {
      if (!this.ui.tieneCargaInicial) return false;
      if (!this.auth.autorizadoEdicionTurno) return false;
      return true;
    },
    datosAsistenciaValidos() {
      var nombre = (this.actual.observadorNombre || "").toString().trim();
      var dni = (this.actual.observadorDni || "").toString().trim();
      return nombre.length > 0 && dni.length > 0;
    },
    registroAsistenciaCompleto() {
      return this.datosAsistenciaValidos && this.actual.b1PermitioIngresoLocalVotacion === true;
    },
    sheetB21Completa() {
      return sheetBoolAnswered(this.actual.b2LocalConElectricidad);
    },
    sheetB22Completa() {
      return sheetBoolAnswered(this.actual.b2AccesoPersonasVulnerables);
    },
    sheetB23Completa() {
      const x = this.actual.b2LocalSenializado;
      if (!sheetBoolAnswered(x)) return false;
      if (x === false) return sheetNonEmpty(this.actual.b2LocalSenializadoDetalle);
      return true;
    },
    sheetB31Completa() {
      const a = this.actual;
      const presencia = !!(
        a.b3PresenciaOnpe ||
        a.b3PresenciaJne ||
        a.b3PresenciaFfaaPnp ||
        a.b3PresenciaMinisterioPublico ||
        a.b3PresenciaDefensoriaDelPueblo ||
        a.b3PresenciaOtros
      );
      if (!presencia) return false;
      if (a.b3PresenciaOtros && !sheetNonEmpty(a.b3PresenciaOtrosDetalle)) return false;
      return true;
    },
    sheetB32Completa() {
      const x = this.actual.b3AreaSufragioPrimerPiso;
      if (!sheetBoolAnswered(x)) return false;
      if (x === false) return sheetNonEmpty(this.actual.b3AreaSufragioPrimerPisoDetalle);
      return true;
    },
    sheetB33Completa() {
      const x = this.actual.b3PropagandaEnLocal;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) {
        if (this.parsePartidoIds(this.actual.b3PropagandaEnLocalOrganizacionParamIds).length === 0) return false;
        return sheetNonEmpty(this.actual.b3PropagandaEnLocalDetalle);
      }
      return true;
    },
    sheetB41Completa() {
      const x = this.actual.b4IncidenteLimitaLaborObservador;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) return sheetNonEmpty(this.actual.b4IncidenteLimitaLaborObservadorDetalle);
      return true;
    },
    sheetB42Completa() {
      const x = this.actual.b4ActoIntimidacionOViolencia;
      if (!sheetBoolAnswered(x)) return false;
      if (x === true) return sheetNonEmpty(this.actual.b4ActoIntimidacionOViolenciaDetalle);
      return true;
    },
  },
  methods: {
    sheetRowQClass(aplica, completa) {
      if (!aplica) return ["form-group", "row"];
      return ["form-group", "row", "sheet-question", completa ? "sheet-question--completada" : "sheet-question--pendiente"];
    },
    fetchPartidosPoliticos() {
      this.$http.get(this.apiRoute("Parameter", "ListParametrosPoliticos"), { params: { Id: this.localVotacionId } })
        .then(function (response) { this.partidos = response.body.data; });
    },
    getImagenPartidoPolitico(partidoPoliticoParamId) {
      var partido = this.partidos.find(x => x.parametroId == partidoPoliticoParamId);
      var imagen = partido ? partido.imagen : "app-partidos/_no-image.png";
      return `${this.apiResource(imagen)}`;
    },
    toggleOrganizacion(campo, parametroId) {
      this.actual[campo] = this.actual[campo] === parametroId ? null : parametroId;
    },
    parsePartidoIds(csv) {
      if (!csv) return [];
      return csv.toString().split(",").map(s => parseInt(s, 10)).filter(n => !isNaN(n));
    },
    isPartidoSelected(campo, parametroId) {
      return this.parsePartidoIds(this.actual[campo]).indexOf(parametroId) !== -1;
    },
    togglePartidoCsv(campo, parametroId) {
      var ids = this.parsePartidoIds(this.actual[campo]);
      var idx = ids.indexOf(parametroId);
      if (idx === -1) ids.push(parametroId);
      else ids.splice(idx, 1);
      this.actual[campo] = ids.length ? ids.join(",") : null;
    },
    validarRegistroAsistencia() {
      return this.isFormValid("frm-local-ficha-asistencia");
    },
    hayDatosCuestionario() {
      var a = this.actual;
      return (
        a.b2LocalConElectricidad !== null ||
        a.b2AccesoPersonasVulnerables !== null ||
        a.b2LocalSenializado !== null ||
        !!a.b2LocalSenializadoDetalle ||
        a.b3PresenciaOnpe !== null ||
        a.b3PresenciaJne !== null ||
        a.b3PresenciaFfaaPnp !== null ||
        a.b3PresenciaMinisterioPublico !== null ||
        a.b3PresenciaDefensoriaDelPueblo !== null ||
        a.b3PresenciaOtros !== null ||
        !!a.b3PresenciaOtrosDetalle ||
        a.b3AreaSufragioPrimerPiso !== null ||
        !!a.b3AreaSufragioPrimerPisoDetalle ||
        a.b3PropagandaEnLocal !== null ||
        !!a.b3PropagandaEnLocalOrganizacionParamIds ||
        !!a.b3PropagandaEnLocalDetalle ||
        a.b4IncidenteLimitaLaborObservador !== null ||
        !!a.b4IncidenteLimitaLaborObservadorDetalle ||
        a.b4ActoIntimidacionOViolencia !== null ||
        !!a.b4ActoIntimidacionOViolenciaDetalle ||
        !!a.cHoraCierreLocal ||
        a.cQuedaronPersonasEsperandoVotar !== null ||
        a.cSePermitioVotarTrasCierre !== null
      );
    },
    resetCuestionarioTurno() {
      var a = this.actual;
      a.b2LocalConElectricidad = null;
      a.b2AccesoPersonasVulnerables = null;
      a.b2LocalSenializado = null;
      a.b2LocalSenializadoDetalle = null;
      a.b3PresenciaOnpe = null;
      a.b3PresenciaJne = null;
      a.b3PresenciaFfaaPnp = null;
      a.b3PresenciaMinisterioPublico = null;
      a.b3PresenciaDefensoriaDelPueblo = null;
      a.b3PresenciaOtros = null;
      a.b3PresenciaOtrosDetalle = null;
      a.b3AreaSufragioPrimerPiso = null;
      a.b3AreaSufragioPrimerPisoDetalle = null;
      a.b3PropagandaEnLocal = null;
      a.b3PropagandaEnLocalOrganizacionParamId = null;
      a.b3PropagandaEnLocalOrganizacionParamIds = null;
      a.b3PropagandaEnLocalDetalle = null;
      a.b4IncidenteLimitaLaborObservador = null;
      a.b4IncidenteLimitaLaborObservadorDetalle = null;
      a.b4ActoIntimidacionOViolencia = null;
      a.b4ActoIntimidacionOViolenciaDetalle = null;
      a.cHoraCierreLocal = null;
      a.cQuedaronPersonasEsperandoVotar = null;
      a.cSePermitioVotarTrasCierre = null;
    },
    seleccionarPermitioIngreso(valor) {
      if (this.actual.b1PermitioIngresoLocalVotacion === valor) return;
      if (!this.validarRegistroAsistencia() || !this.datosAsistenciaValidos) {
        this.$bvToast.toast("Completa el Nombre del Observador y DNI antes de continuar.", { title: "Registro de Asistencia", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return;
      }
      if (valor === false && this.hayDatosCuestionario()) {
        var vm = this;
        this.$bvModal.msgBoxConfirm(
          "Se borrarán todos los datos ya registrados en el cuestionario de esta ficha. ¿Deseas continuar?",
          {
            title: "Confirmar cambio",
            okTitle: "Sí, borrar y continuar",
            cancelTitle: "Cancelar",
            okVariant: "danger",
            centered: true,
          }
        ).then(function (confirmado) {
          if (!confirmado) return;
          vm.resetCuestionarioTurno();
          vm.$set(vm.actual, "b1PermitioIngresoLocalVotacion", false);
        });
        return;
      }
      this.$set(this.actual, "b1PermitioIngresoLocalVotacion", valor);
    },
    limpiarPropagandaLocal() {
      this.actual.b3PropagandaEnLocal = false;
      this.actual.b3PropagandaEnLocalOrganizacionParamId = null;
      this.actual.b3PropagandaEnLocalOrganizacionParamIds = null;
      this.actual.b3PropagandaEnLocalDetalle = null;
    },
    limpiarCierre() {
      this.actual.cQuedaronPersonasEsperandoVotar = false;
      this.actual.cSePermitioVotarTrasCierre = null;
    },
    inicializarGuardado() {
      if (!this.intervaloAutoGuardado || this.intervaloAutoGuardado <= 0) return;
      if (!this.ui.tieneCargaInicial || this.ui.estaCargandoDatos) return;
      if (!this.auth.autorizadoEdicionTurno) return;
      var vm = this;
      clearTimeout(this.temporizadorGuardado);
      this.temporizadorGuardado = setTimeout(function () {
        if (!vm.ui.estaCargandoDatos && !vm.ui.estaGuardando && vm.isDirty) vm.doGuardado(true);
      }, this.intervaloAutoGuardado);
    },
    actualizarBaseDiferente(propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      var vActual = JSON.stringify(fichaActual[propiedad]);
      var vGuardado = JSON.stringify(fichaGuardado[propiedad]);
      var vActualizado = JSON.stringify(fichaActualizada[propiedad]);
      return (vActual == vGuardado && vGuardado != vActualizado) ? fichaActualizada[propiedad] : fichaActual[propiedad];
    },
    doCargarFicha: async function () {
      this.ui.estaCargandoDatos = true;
      var model = { localVotacionId: this.localVotacionId, procesoElectoralId: this.procesoElectoralId };

      await this.$http.post(this.apiRoute("Sheet", "GetFichaTurnoUno"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var ficha = response.body.data.ficha;
          var tempActual = this.cloneObject(this.actual);
          var tempGuardado = this.cloneObject(this.guardado);

          var campos = Object.keys(tempActual);
          campos.forEach(c => { tempActual[c] = this.actualizarBaseDiferente(c, tempActual, tempGuardado, ficha); });

          this.actual = this.cloneObject(tempActual);
          this.guardado = this.cloneObject(this.actual);
          this.auth = response.body.data.auth;
          this.localNombre = response.body.data.localNombre;
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
    },
    doGuardado: async function (omitirNotificacion) {
      if (this.ui.estaGuardando) return;
      if (omitirNotificacion == true && !this.datosAsistenciaValidos) return false;
      if (!this.validarRegistroAsistencia() || !this.datosAsistenciaValidos) {
        if (omitirNotificacion != true) this.$bvToast.toast("Completa el Nombre del Observador y DNI antes de guardar.", { title: "Ficha Local", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return false;
      }
      if (this.actual.b3PropagandaEnLocal === true && this.parsePartidoIds(this.actual.b3PropagandaEnLocalOrganizacionParamIds).length === 0) {
        if (omitirNotificacion != true) this.$bvToast.toast("Selecciona al menos una organización política para la pregunta de propaganda electoral.", { title: "Ficha Local", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return false;
      }
      if (!this.isFormValid("frm-local-ficha")) {
        if (omitirNotificacion != true) this.$bvToast.toast("Hay campos con valores incorrectos.", { title: "Ficha Local", autoHideDelay: 5000, variant: "warning", appendToast: false, solid: true });
        return false;
      }

      var actualClone = this.cloneObject(this.actual);
      var model = this.cloneObject(this.actual);
      model.localVotacionId = this.localVotacionId;
      model.procesoElectoralId = this.procesoElectoralId;

      var guardadoExitoso = false;
      this.ui.estaGuardando = true;
      await this.$http.post(this.apiRoute("Sheet", "EditFichaTurnoUno"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.guardado = actualClone;
          if (omitirNotificacion != true) this.$bvToast.toast("Los cambios se han guardado correctamente.", { title: "Ficha Local", autoHideDelay: 5000, variant: "success", appendToast: false, solid: true });
          guardadoExitoso = true;
          this.doCargarFicha();
          this.$notifyHub.notificarCambioFicha(this.procesoElectoralId, this.localVotacionId, 1);
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.estaGuardando = false;
      return guardadoExitoso;
    },
  },
  watch: {
    actual: {
      deep: true,
      handler() {
        if (this.intervaloAutoGuardado && this.intervaloAutoGuardado > 0 && this.ui.tieneCargaInicial && !this.ui.estaCargandoDatos && this.auth.autorizadoEdicionTurno) {
          this.inicializarGuardado();
        }
      },
    },
  },
  mounted() {
    this.initParsley();
    this.fetchPartidosPoliticos();
    this.doCargarFicha();
  },
  beforeDestroy() {
    clearTimeout(this.temporizadorGuardado);
  },
};
</script>

<style scoped>
.card-body .btn-outline-secondary {
  background-color: #fff;
}
</style>
